module.exports = __webpack_public_path__ + "img/mascote_mapa.27a634b9.png";